import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
      image: {
        marginLeft: '15px',
        borderRadius: 15,
        margin: '20px 0',
      },
}))